/**
 * Logger Utility
 * - log / warn: console only, and only in development
 * - error: always logged, and always reported to PostHog as an exception.
 *   Use it only for failures nothing else reports; where a dedicated event
 *   already reports the failure, log with warn instead so it is not counted twice.
 *
 * Usage: Replace `console.log()` with `logger.log()`
 */

import { reportException } from './posthog-tracker'

const isDev = import.meta.env.DEV

export const logger = {
  log: (...args: unknown[]) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.log(...args)
    }
  },
  warn: (...args: unknown[]) => {
    if (isDev) {
      console.warn(...args)
    }
  },
  error: (message: string, cause?: unknown, context: Record<string, unknown> = {}) => {
    console.error(message, ...(cause === undefined ? [] : [cause]))
    // Logging must not fail because reporting did.
    try {
      reportException(
        cause instanceof Error ? cause : new Error(cause === undefined ? message : `${message} ${String(cause)}`),
        { log_message: message, ...context },
      )
    }
    catch {}
  },
}
